var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderPlus01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14L10 11.1716M10 11.1716L10 8.34317M10 11.1716L7.1716 11.1716M10 11.1716L12.8285 11.1716M2.00081 14.6175L2.00089 7.0139C2.00089 6.2523 2.00061 5.16753 2.00037 4.38207C2.0002 3.82964 2.44797 3.38232 3.00041 3.38232H7.76558L10.0698 5.84369H17C17.5523 5.84369 18 6.29142 18 6.84372L17.9998 14.6176C17.9997 15.7222 17.1043 16.6176 15.9998 16.6176L4.00081 16.6175C2.89623 16.6175 2.0008 15.7221 2.00081 14.6175Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPlus01);
export default __webpack_public_path__ + "static/media/folder-plus-01.726668875a0093a3c4d178bab70553d1.svg";
export { ForwardRef as ReactComponent };